import { apiClient } from "./client";
import { MOCKS_ENABLED } from "./mock/registry";
import { mockRoles } from "./mock/roles";
import type {
  PermissionResponse,
  RoleResponse,
  UserRolesRequest,
  UserRolesResponse,
} from "../types/role";

const realRolesApi = {
  list() {
    return apiClient.get<RoleResponse[]>("/v1/roles").then((r) => r.data);
  },
  get(id: string) {
    return apiClient.get<RoleResponse>(`/v1/roles/${id}`).then((r) => r.data);
  },
  permissions() {
    return apiClient.get<PermissionResponse[]>("/v1/permissions").then((r) => r.data);
  },
  userRoles(userId: string) {
    return apiClient.get<UserRolesResponse>(`/v1/users/${userId}/roles`).then((r) => r.data);
  },
  replaceUserRoles(userId: string, req: UserRolesRequest) {
    return apiClient
      .put<UserRolesResponse>(`/v1/users/${userId}/roles`, req)
      .then((r) => r.data);
  },
};

// Routes to the mock adapter until the real `/api/v1/roles` is wired
// end-to-end (auth + tenant). Flip via `VITE_USE_MOCKS=false`.
export const rolesApi = MOCKS_ENABLED ? mockRoles : realRolesApi;

export const rolesQueryKeys = {
  all: ["roles"] as const,
  list: () => ["roles", "list"] as const,
  detail: (id: string) => ["roles", "detail", id] as const,
  permissions: () => ["permissions"] as const,
  userRoles: (userId: string) => ["users", userId, "roles"] as const,
};
